import { render, staticRenderFns } from "./EditableBadge.vue?vue&type=template&id=500ab5cc&scoped=true"
import script from "./EditableBadge.vue?vue&type=script&lang=js"
export * from "./EditableBadge.vue?vue&type=script&lang=js"
import style0 from "./EditableBadge.vue?vue&type=style&index=0&id=500ab5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ab5cc",
  null
  
)

export default component.exports